var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "jRules" },
    [
      _c(
        "div",
        { staticClass: "wrap" },
        [
          _c(
            "div",
            { staticClass: "bullet-center fl-right" },
            [
              _c("router-link", { attrs: { to: "/flows" } }, [
                _c("i", { staticClass: "fa fa-times" })
              ])
            ],
            1
          ),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _c("div", [
            !_vm.flow[0]
              ? _c("h4", { staticClass: "select-rules" }, [
                  _vm._v("\n        Select some flow to create rules\n      ")
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("b-col"),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "10" } },
                [
                  _c("jRulesTableNew", {
                    ref: "tableRules",
                    on: { rowClick: _vm.rowClick }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("b-col")
            ],
            1
          ),
          _vm._v(" "),
          _vm.flow[0]
            ? _c(
                "div",
                { staticClass: "selected-bottom-rules" },
                [
                  _c(
                    "b-row",
                    [
                      _c("b-col"),
                      _vm._v(" "),
                      _c("b-col", { attrs: { cols: "10" } }, [
                        _c("h2", [_vm._v("Rules-01")]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "overflow-scroll" },
                          [
                            _c("div", { staticClass: "inline--block" }, [
                              _c(
                                "div",
                                { staticClass: "flow-new__bullet-top" },
                                [_c("i", { staticClass: "fa fa-square" })]
                              )
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.flow, function(anu, index) {
                              return _c(
                                "div",
                                { key: index, staticClass: "inline--block" },
                                [
                                  index === 0
                                    ? _c("div", {
                                        staticClass: "line-horizontal"
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  index > 0
                                    ? _c("div", {
                                        staticClass: "line-horizontal next-line"
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "inline--block" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "flow-table flow-arrow light-blue-flow"
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(anu.name) +
                                            "\n                "
                                        )
                                      ]
                                    )
                                  ])
                                ]
                              )
                            })
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "wrap-button-flow" },
                          [
                            _c(
                              "b-button",
                              {
                                staticClass: "btn blue",
                                on: {
                                  click: function($event) {
                                    _vm.$refs.saveRules.show()
                                  }
                                }
                              },
                              [_vm._v("\n              CREATE\n            ")]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-button",
                              {
                                staticClass: "btn blue outline",
                                on: { click: _vm.clearRules }
                              },
                              [_vm._v("\n              CLEAR\n            ")]
                            )
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("b-col")
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "saveRules",
          staticClass: "mod-form save-flow-approver",
          attrs: { centered: "" }
        },
        [
          _c(
            "div",
            {
              staticClass: "close-modal-rules",
              on: {
                click: function($event) {
                  _vm.$refs.saveRules.hide()
                }
              }
            },
            [_c("i", { staticClass: "fa fa-times" })]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "title-rules" }, [
            _c("i", { staticClass: "fa fa-square" }),
            _vm._v("\n      Save Rules\n    ")
          ]),
          _vm._v(" "),
          _c(
            "b-form-group",
            { class: { "error-input": _vm.$v.rule_name.$error } },
            [
              _c("label", [_vm._v("Rules Name*")]),
              _vm._v(" "),
              _c("j-input", {
                attrs: { "max-length": 50, placeholder: "ex: Carry" },
                model: {
                  value: _vm.rule_name,
                  callback: function($$v) {
                    _vm.rule_name = $$v
                  },
                  expression: "rule_name"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "wrap-button-rules" },
            [
              _c(
                "b-button",
                { staticClass: "btn blue", on: { click: _vm.saveRules } },
                [_vm._v("\n        SAVE\n      ")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.flow[0] ? _c("div", { staticClass: "space-more" }) : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bullet-center" }, [
      _c("h2", [_vm._v("Create Rules")]),
      _vm._v(" "),
      _c("br")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e5b44ac6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e5b44ac6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/flow-rule/rules/jRulesNew.vue
// module id = null
// module chunks = 